/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/interface-name-prefix */
import React, { useEffect, useState } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import SeriesDetailLink from 'Components/links/series-detail'
import classnames from 'classnames'
import { useResponsive } from 'Components/hooks/use-responsive'
import getUrl from 'lib/url'
import fetch from 'lib/decorated-fetch'
import SwiperButton from 'Components/swiper-button'
import { Image } from 'Components/view-image'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { logger } from 'lib/slardar-utils'
import TryCatchRender from 'Components/try-catch-render'
import ResponsiveSwiper, {
  ResponsiveConfig,
} from 'Components/new/responsive-swiper'
import useLazyRender from 'Components/hooks/use-lazy-render'
import style from './index.module.scss'
import batchedUpdates from 'lib/batched-updates'

export interface IPanoramicCar {
  ns_cover_url: string
  panoramic_url: string
  series_name: string
  series_id: number
}

interface ICarData {
  value: number | string
  text: string
  link: string
}

export interface ISeriesData {
  series_id: number
  series_name: string
  cover_url: string
  series_type: number //车系类型 0 轿车 1 suv 2 mpv
  is_new_energy: boolean // 是否是新能源
}
interface IConfig {
  [key: string]: {
    page: number
    types: number[]
  }
}

//   - 4列（1920）：4列*2行*6切=48个内容（最大值）
// - 3列（1680/1440/1280/1024）：3列*2行*8切=48个内容（最大值）

// - 1）4列（1920）: 每一组数据8个（轿车2、suv2、mpv 2、新能源2）；排序（轿车>suv>mpv>新能源）； 点击后跳转车系首页
// - 2) 3列（1680/1440/1280/1024）：每一组数据6个（轿车2、suv2、mpv1、新能源1）；排序（轿车>suv>mpv>新能源）；点击后跳转车系首页

const pageConfig: IConfig = {
  8: {
    page: 6,
    types: [2, 2, 2, 2],
  },
  6: {
    page: 8,
    types: [2, 2, 1, 1],
  },
}

const smNum = 6
const lgNum = 8

export const getCarAtlasData = async (req?: any) => {
  const params = {
    limousine_pic_num: 16,
    suv_pic_num: 16,
    mpv_pic_num: 12,
    energy_pic_num: 12,
    panoramic_pic_num: 2,
    total_pic_num: 58,
  }
  const url = getUrl(
    `/motor/pc/car/rcm_picture?${serializeObject(params)}`,
    'motor.pc_car.api'
  )
  const json = await fetch(url, {
    req,
  }).catch((err) => {
    logger.warn(`[fetch] carAtlasData error. err=${err.message}`)
    return {}
  })
  const data = json?.data || {}
  return data
}

const cols: ResponsiveConfig = {
  sm: 3,
  md: 3,
  lg: 3,
  xl: 3,
  '2xl': 4,
}

const rows: ResponsiveConfig = {
  sm: 2,
  md: 2,
  lg: 2,
  xl: 2,
  '2xl': 2,
}

function CarAtlas() {
  const carList = [
    {
      value: 0,
      text: '轿车',
      link: '/auto/library-picture/x-0-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: 1,
      text: 'SUV',
      link: '/auto/library-picture/x-1-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: 2,
      text: 'MPV',
      link: '/auto/library-picture/x-2-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: 4,
      text: '跑车',
      link: '/auto/library-picture/x-4-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: '4,5,6',
      text: '新能源',
      link: '/auto/library-picture/x-x-x-x-x-x-4,5,6-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: 3,
      text: '皮卡',
      link: '/auto/library-picture/x-3-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: 7,
      text: '微面',
      link: '/auto/library-picture/x-7-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: 8,
      text: '微卡',
      link: '/auto/library-picture/x-8-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
    {
      value: 6,
      text: '轻客',
      link: '/auto/library-picture/x-6-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x',
    },
  ]

  const [seriesList, setSeriesList] = useState([])
  const [swiperCarList, setSwiperCarList] = useState<ISeriesData[]>([])
  const [panoramicCarList, setPanoramicCarList] = useState([])

  const responsive = useResponsive()

  const computedCarList = (num: number, seriesList: ISeriesData[]) => {
    const typeList: ISeriesData[][] = [[], [], []]
    const newEnergy: ISeriesData[] = []
    seriesList?.forEach((item) => {
      if (item?.is_new_energy) {
        newEnergy?.push(item)
      } else {
        if (typeList?.[item.series_type]) {
          typeList[item.series_type].push(item)
        }
      }
    })
    typeList?.push(newEnergy)
    let result: ISeriesData[] = []
    let isContinue = true
    let times = 0
    const currentPageConfig = pageConfig?.[num]
    while (isContinue) {
      let isAdd = true // 必须遍历添加完整的一组数组
      let tmp: ISeriesData[] = []
      currentPageConfig?.types?.forEach((value, index) => {
        if (typeList?.[index]?.length < value) {
          isAdd = false
          return
        }
        tmp = tmp.concat(typeList?.[index]?.splice(0, value))
      })
      if (isAdd) {
        result = result?.concat(tmp)
        times++
      } else {
        isContinue = false
      }
      if (result?.length >= currentPageConfig?.page * num) {
        isContinue = false
      }
    }
    setSwiperCarList(result)
  }

  useEffect(() => {
    let num = smNum
    if (responsive['2xl']) {
      num = lgNum
    }
    computedCarList(num, seriesList || [])
  }, [seriesList, responsive?.['2xl']])

  useEffect(() => {
    async function init() {
      try {
        const data = await getCarAtlasData(null)
        batchedUpdates(() => {
          setSeriesList(data?.nice_series_list || [])
          setPanoramicCarList(data?.panoramic_car_list || [])
        })
      } catch (error) {
        logger.warn(
          `[fetch] carAtlasData error. err=${(error as Error).message}`
        )
      }
    }
    init()
  }, [])

  /* 渲染车型的分类 */
  function renderCar(param: ICarData, index: number) {
    return (
      <a
        key={`${index}-${param.value}`}
        target={'_blank'}
        className={`${style['header-list-item']} fl`}
        href={param.link}
        onClick={() => {
          sendTeaCommEvent('clk_event', {
            event_id: 'series_pic_module_keywords',
            module_id: 'series_pic_module',
            button_name: param.text,
          })
        }}
      >
        {param.text}
      </a>
    )
  }

  function textLink(
    item: any,
    index: number,
    id: string,
    type: string,
    button_name?: string
  ) {
    return (
      <a
        target={'_blank'}
        className="g-active-white-text"
        href={`/auto/series/${item?.series_id}/images-${type || 'wg'}`}
        onClick={() => {
          sendTeaCommEvent('clk_event', {
            event_id: id,
            car_series_id: `${item?.series_id}`,
            car_series_name: button_name || item?.series_name,
            rank: index,
            module_id: 'series_pic_module',
            button_name: button_name || '',
          })
        }}
      >
        <span className="tw-px-4">{button_name || item?.series_name}</span>
      </a>
    )
  }

  /* 底部文字 */
  function renderTextLine(item: any, index: number) {
    return (
      <div className={style['series-name']}>
        <p
          className={`${style['name-title']} g-active-white-text g-one-line-text`}
        >
          {textLink(item, index, 'series_pic_module_series_text', '')}
        </p>
        <p className={style['series-link']}>
          {textLink(item, index, 'series_pic_module_pic_btn', 'wg', '外观')}|
          {textLink(item, index, 'series_pic_module_pic_btn', 'ns', '内饰')}|
          {textLink(item, index, 'series_pic_module_pic_btn', 'kj', '空间')}
        </p>
      </div>
    )
  }
  const [prevEl, setPrevEl] = useState<HTMLElement | null>(null)
  const [nextEl, setNextEl] = useState<HTMLElement | null>(null)

  return (
    <div
      // ref={ref}
      className={style['car-atlas-wrapper']}
      data-log-view-config={JSON.stringify({
        repeated: true,
      })}
      data-log-view={JSON.stringify({
        event: 'show_event',
        params: {
          event_id: 'common_conponent_module',
          module_id: 'series_pic_module',
        },
      })}
    >
      <div className={style['car-atlas']}>
        <div className="tw-grid tw-grid-cols-12 tw-gap-12">
          <div className={`${style['header']} ${style['car-atlas-header']}`}>
            <div className={`${style['title']} fl`}>
              <a
                target={'_blank'}
                href="/picture"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'series_pic_module_tilte',
                    module_id: 'series_pic_module',
                  })
                }}
              >
                精美车图
              </a>
            </div>
            <div className={style['header-list']}>
              {carList?.map((item: ICarData, index: number) =>
                renderCar(item, index)
              )}
              <a
                target={'_blank'}
                className={style['more']}
                href="/auto/library-picture/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'series_pic_module_keywords',
                    module_id: 'series_pic_module',
                    button_name: '更多',
                  })
                }}
              >
                更多
                <i className={`${style['more-icon']} icon-up-arrow-ic`} />
              </a>
            </div>
          </div>
          <div
            className={`${style['car-atilas-swiper']} tw-col-span-12 tw-mt-52`}
          >
            <ResponsiveSwiper
              slideCount={swiperCarList?.length || 8}
              cols={cols}
              rows={rows}
              gap={12}
              slideClass="tw-w-100/3 2xl:tw-w-2.5"
              navigation={{
                prevEl,
                nextEl,
              }}
              onSlideChange={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'series_pic_module_change',
                  module_id: 'series_pic_module',
                })
              }}
            >
              {({ index, activeIndex }) => {
                const item = swiperCarList?.[index]
                return swiperCarList?.length ? (
                  <div className={style['image-wrapper']}>
                    <div
                      className={`${style['image-transition']} ${style['small-image-wrap']} g-load-img-wrap`}
                    >
                      <SeriesDetailLink
                        id={`${item?.series_id}`}
                        onClick={() => {
                          sendTeaCommEvent('clk_event', {
                            event_id: 'series_pic_module_pic',
                            car_series_id: `${item?.series_id}`,
                            car_series_name: item?.series_name,
                            rank: activeIndex,
                            material_url: item?.cover_url,
                            module_id: 'series_pic_module',
                          })
                        }}
                      >
                        <Image
                          src={item?.cover_url}
                          alt={item?.series_name}
                          lazy={true}
                          width={310}
                          height={206}
                          layout="fill"
                          hoverTransition
                          autoPixelRatio
                        />
                      </SeriesDetailLink>
                      {renderTextLine(item, index)}
                    </div>
                  </div>
                ) : (
                  <div className={style['image-wrapper']}>
                    <div
                      className={classnames(
                        style['image-transition'],
                        style['small-image-wrap'],
                        'g-load-img-wrap',
                        {
                          'tw-hidden': index >= 6,
                          '2xl:tw-block': index >= 6,
                        }
                      )}
                    >
                      <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIvPg==" />
                    </div>
                  </div>
                )
              }}
            </ResponsiveSwiper>

            <SwiperButton
              ref={setPrevEl}
              type="prev"
              buttonStyle={{
                position: 'absolute',
                right: '42px',
                top: '3px',
              }}
              className="swiper-button-disabled"
            />
            <SwiperButton
              ref={setNextEl}
              type="next"
              buttonStyle={{
                position: 'absolute',
                right: '12px',
                top: '3px',
              }}
            />
          </div>
        </div>
      </div>
      <div className={`${style['car-pano-wrapper']} fr`}>
        <div className={style['header']}>
          <div
            className={style['title']}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: '360_view_module_title',
                module_title: '360度看车',
                module_id: '360_view_module',
              })
            }}
          >
            360度看车
          </div>
        </div>
        {panoramicCarList?.length ? (
          panoramicCarList?.map(
            (panoramicCar: IPanoramicCar, index: number) => {
              return (
                <a
                  key={index}
                  onClick={() => {
                    sendTeaCommEvent('clk_event', {
                      event_id: '360_view_module_item',
                      car_series_id: `${panoramicCar?.series_id}`,
                      car_series_name: panoramicCar?.series_name,
                      rank: `${index}`,
                      module_id: '360_view_module',
                    })
                  }}
                  target={'_blank'}
                  rel={
                    panoramicCar?.panoramic_url?.includes('www.dongchedi.com')
                      ? undefined
                      : 'nofollow'
                  }
                  href={panoramicCar?.panoramic_url}
                >
                  <div
                    className={`${style['car-pano']} ${style['image-transition']} ${style['small-image-wrap']} g-load-img-wrap`}
                  >
                    <div className={style['car-pano-mask']} />
                    <Image
                      src={panoramicCar?.ns_cover_url}
                      lazy={true}
                      width={200}
                      height={140}
                      alt={panoramicCar?.series_name}
                      hoverTransition
                      layout="responsive"
                    />
                    <div className={style['series-name']}>
                      <p
                        className={`${style['name-title']} g-active-white-text g-one-line-text`}
                      >
                        {panoramicCar?.series_name} - 360°全景内饰
                      </p>
                    </div>
                  </div>
                </a>
              )
            }
          )
        ) : (
          <>
            <div
              className={`${style['car-pano']} ${style['image-transition']} ${style['small-image-wrap']} g-load-img-wrap`}
            />
            <div
              className={`${style['car-pano']} ${style['image-transition']} ${style['small-image-wrap']} g-load-img-wrap`}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default CarAtlas
